export function nameInitials(fullName: string): string {
    const split = fullName.split(" ");

    if (split.length === 0) {
        return "";
    }

    const lastSplit = split.length > 1 ? split[split.length - 1] : undefined;

    return `${split[0].charAt(0).toUpperCase()}${lastSplit ? lastSplit.charAt(0).toUpperCase() : ""}`;
}
